/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TextbookType = "CORE_TEXTBOOK" | "LEGACY" | "SKILLS_BOOK";
export type FreeTextbooksTopicSubtopicTreeQueryVariables = {
    syllabusId: string;
    isSearch: boolean;
    search: string;
};
export type FreeTextbooksTopicSubtopicTreeQueryResponse = {
    readonly syllabus?: {
        readonly id: string;
        readonly title: string;
        readonly thumbnailImageUrl: string;
        readonly overview: {
            readonly id: string;
        } | null;
        readonly topics: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly title: string;
                    readonly badgeUrl: string;
                    readonly syllabus: {
                        readonly textbookType: TextbookType;
                    };
                    readonly subtopics: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string;
                                readonly title: string;
                                readonly hasExercise: boolean;
                                readonly hasLessons: boolean;
                                readonly hasInvestigations: boolean;
                                readonly hasWorksheet: boolean;
                            };
                        }>;
                    };
                };
            }>;
        };
    } | null | undefined;
    readonly syllabusSearchResult?: {
        readonly id: string;
        readonly topics: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly topic: {
                        readonly id: string;
                        readonly title: string;
                        readonly badgeUrl: string;
                        readonly syllabus: {
                            readonly textbookType: TextbookType;
                        };
                    };
                    readonly subtopics: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly subtopic: {
                                    readonly id: string;
                                    readonly title: string;
                                    readonly hasExercise: boolean;
                                    readonly hasLessons: boolean;
                                    readonly hasInvestigations: boolean;
                                    readonly hasWorksheet: boolean;
                                };
                            };
                        }>;
                    };
                };
            }>;
        };
    } | null | undefined;
};
export type FreeTextbooksTopicSubtopicTreeQuery = {
    readonly response: FreeTextbooksTopicSubtopicTreeQueryResponse;
    readonly variables: FreeTextbooksTopicSubtopicTreeQueryVariables;
};



/*
query FreeTextbooksTopicSubtopicTreeQuery(
  $syllabusId: ID!
  $isSearch: Boolean!
  $search: String!
) {
  syllabus(id: $syllabusId) @skip(if: $isSearch) {
    id
    title
    thumbnailImageUrl
    overview {
      id
    }
    topics(first: 1000) {
      edges {
        node {
          id
          title
          badgeUrl
          syllabus {
            textbookType
            id
          }
          subtopics(first: 1000) {
            edges {
              node {
                id
                title
                hasExercise
                hasLessons
                hasInvestigations
                hasWorksheet
              }
            }
          }
        }
      }
    }
  }
  syllabusSearchResult(syllabusId: $syllabusId, query: $search) @include(if: $isSearch) {
    id
    topics(first: 1000) {
      edges {
        node {
          topic {
            id
            title
            badgeUrl
            syllabus {
              textbookType
              id
            }
          }
          subtopics(first: 1000) {
            edges {
              node {
                subtopic {
                  id
                  title
                  hasExercise
                  hasLessons
                  hasInvestigations
                  hasWorksheet
                }
                id
              }
            }
          }
          id
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "syllabusId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "syllabusId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailImageUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "SyllabusOverview",
  "kind": "LinkedField",
  "name": "overview",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "badgeUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textbookType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "FreeTextbookSyllabus",
  "kind": "LinkedField",
  "name": "syllabus",
  "plural": false,
  "selections": [
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasExercise",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasLessons",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasInvestigations",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasWorksheet",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "FreeTextbookSubtopicConnection",
  "kind": "LinkedField",
  "name": "subtopics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FreeTextbookSubtopicEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FreeTextbookSubtopic",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "subtopics(first:1000)"
},
v14 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "syllabusId",
    "variableName": "syllabusId"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "FreeTextbookSubtopic",
  "kind": "LinkedField",
  "name": "subtopic",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "FreeTextbookSyllabus",
  "kind": "LinkedField",
  "name": "syllabus",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FreeTextbooksTopicSubtopicTreeQuery",
    "selections": [
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "FreeTextbookSyllabus",
            "kind": "LinkedField",
            "name": "syllabus",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "FreeTextbookTopicConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextbookTopicEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreeTextbookTopic",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "topics(first:1000)"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "FreeTextbookSyllabusSearchResult",
            "kind": "LinkedField",
            "name": "syllabusSearchResult",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "FreeTextbookTopicSearchResultConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextbookTopicSearchResultEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreeTextbookTopicSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FreeTextbookTopic",
                            "kind": "LinkedField",
                            "name": "topic",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v8/*: any*/),
                            "concreteType": "FreeTextbookSubtopicSearchResultConnection",
                            "kind": "LinkedField",
                            "name": "subtopics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FreeTextbookSubtopicSearchResultEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FreeTextbookSubtopicSearchResult",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "subtopics(first:1000)"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "topics(first:1000)"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FreeTextbooksTopicSubtopicTreeQuery",
    "selections": [
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "FreeTextbookSyllabus",
            "kind": "LinkedField",
            "name": "syllabus",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "FreeTextbookTopicConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextbookTopicEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreeTextbookTopic",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v9/*: any*/),
                          (v16/*: any*/),
                          (v13/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "topics(first:1000)"
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "isSearch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "FreeTextbookSyllabusSearchResult",
            "kind": "LinkedField",
            "name": "syllabusSearchResult",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "FreeTextbookTopicSearchResultConnection",
                "kind": "LinkedField",
                "name": "topics",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FreeTextbookTopicSearchResultEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FreeTextbookTopicSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FreeTextbookTopic",
                            "kind": "LinkedField",
                            "name": "topic",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v8/*: any*/),
                            "concreteType": "FreeTextbookSubtopicSearchResultConnection",
                            "kind": "LinkedField",
                            "name": "subtopics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FreeTextbookSubtopicSearchResultEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FreeTextbookSubtopicSearchResult",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "subtopics(first:1000)"
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "topics(first:1000)"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1e712d09f325a9fbab0acb44d5a0a9f5",
    "id": null,
    "metadata": {},
    "name": "FreeTextbooksTopicSubtopicTreeQuery",
    "operationKind": "query",
    "text": "query FreeTextbooksTopicSubtopicTreeQuery(\n  $syllabusId: ID!\n  $isSearch: Boolean!\n  $search: String!\n) {\n  syllabus(id: $syllabusId) @skip(if: $isSearch) {\n    id\n    title\n    thumbnailImageUrl\n    overview {\n      id\n    }\n    topics(first: 1000) {\n      edges {\n        node {\n          id\n          title\n          badgeUrl\n          syllabus {\n            textbookType\n            id\n          }\n          subtopics(first: 1000) {\n            edges {\n              node {\n                id\n                title\n                hasExercise\n                hasLessons\n                hasInvestigations\n                hasWorksheet\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  syllabusSearchResult(syllabusId: $syllabusId, query: $search) @include(if: $isSearch) {\n    id\n    topics(first: 1000) {\n      edges {\n        node {\n          topic {\n            id\n            title\n            badgeUrl\n            syllabus {\n              textbookType\n              id\n            }\n          }\n          subtopics(first: 1000) {\n            edges {\n              node {\n                subtopic {\n                  id\n                  title\n                  hasExercise\n                  hasLessons\n                  hasInvestigations\n                  hasWorksheet\n                }\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ce7457fc82d87ae8f5382a8a4fed40a8';
export default node;
